import { Switch } from '../../../../components';
import {
    AnnotatedIllustration,
    Carousel,
    Exercise,
    LabelBody,
    LabelDisplay1,
    LabelDisplay2,
    ProgressBar,
    SecondaryButton,
    Spacer,
    SwirlyBox,
    Tip,
} from '../../components';
import { ExerciseData, ExerciseViewProps } from '../../exercises';
import {
    IllustrationPersonCooking,
    IllustrationPersonTalking,
    IllustrationPersonWatchingTheSun,
    IllustrationPizzaBaker,
    IllustrationThreeBirds,
} from '../../icons';
import { ExerciseStatus } from '../../interfaces';

export const exerciseData25: ExerciseData = {
    ExerciseView: Module2Exercise5,
    dataKeys: [],
    questions: [],
};

function Module2Exercise5({ exercise, onContinue }: ExerciseViewProps) {
    return (
        <Exercise title="Sanseaktivering">
            <ProgressBar current={exercise.CurrentPage} total={2} />
            <Switch
                cases={{
                    1: (
                        <Page1
                            onContinue={() => {
                                onContinue({
                                    status: ExerciseStatus.InProgress,
                                    pageNumber: 2,
                                });
                            }}
                        />
                    ),
                    2: (
                        <Page2
                            onContinue={() => {
                                onContinue({
                                    status: ExerciseStatus.Completed,
                                    goToNext: false,
                                });
                            }}
                        />
                    ),
                }}
                value={exercise.CurrentPage}
                default={1}
            />
        </Exercise>
    );
}

type Page1Props = { onContinue: () => void };
function Page1({ onContinue }: Page1Props) {
    return (
        <>
            <LabelDisplay2>Aktiver din bremse: Brug dine sanser</LabelDisplay2>
            <LabelBody class="my-10">
                Det kan være hårdt hele tiden at forholde sig til os selv, og
                det er okay, at vælge at tage en pause fra at mærke efter og i
                stede fokusere på noget ydre. Dette er dine sanser et fantastisk
                redskab til.
            </LabelBody>
            <LabelBody class="mb-30">
                Denne øvelse vil guide dig i at komme i kontakt med dine
                omgivelser, gennem dine sanser.
            </LabelBody>
            <LabelDisplay1>Sådan gør du</LabelDisplay1>
            <LabelBody class="mb-30 mt-10">
                Gå igennem dine sanser, én for én: følesansen, synssansen,
                høresansen, lugtesansen og smagssansen og læg mærke til, hvad
                der er omkring dig. Du kan gå igennem dem på denne her måde.
            </LabelBody>
            <Carousel
                pages={[
                    <AnnotatedIllustration
                        image={<IllustrationPersonWatchingTheSun />}
                        title="Tre ting du kan mærke"
                        body="F.eks. vinden mod din hud, solen på dit ansigt, trøjen du har på"
                    />,
                    <AnnotatedIllustration
                        image={<IllustrationThreeBirds />}
                        title="Tre ting du kan se"
                        body="F.eks. en hæk, naboens hund, en fugl"
                    />,
                    <AnnotatedIllustration
                        image={<IllustrationPersonTalking />}
                        title="Tre ting du kan høre"
                        body="F.eks. en bil i området, noget der bevæger sig i busken, nogen der taler"
                    />,
                    <AnnotatedIllustration
                        image={<IllustrationPersonCooking />}
                        title="Tre ting du kan lugte"
                        body="F.eks. dig selv, mados fra området, skovbund"
                    />,
                    <AnnotatedIllustration
                        image={<IllustrationPizzaBaker />}
                        title="Måske har du også en smag i munden?"
                        body="Hvad er det?"
                    />,
                ]}
            />
            <Tip className="my-30">
                Giv dig selv et par minutter, hvor du bare ér og mærker det, der
                er omkring dig og din krop. En dybere vejrtrækning kan hjælpe
                dig. Du kan prøve at trække vejret ned i maven, mens du laver
                øvelsen.
            </Tip>
            <SwirlyBox>
                Når du har lagt mærke til dine sanser, kan du gå videre.
            </SwirlyBox>
            <Spacer class="mt-30" />
            <SecondaryButton onClick={onContinue}>Fortsæt</SecondaryButton>
        </>
    );
}

type Page2Props = { onContinue: () => void };
function Page2({ onContinue }: Page2Props) {
    return (
        <>
            <LabelDisplay2>Et godt redskab</LabelDisplay2>
            <LabelBody class="mt-10">
                Når du bevidst aktiverer dine sanser, kommer du mere ned i din
                krop og bliver stille og roligt filtret ud af dine tanker.
            </LabelBody>
            <LabelBody class="mt-10">
                Øvelsen kan laves, lige meget hvor du er, når du opdager, at du
                har svært ved at være til stede nu og her.
            </LabelBody>
            <LabelBody class="mt-10">
                Selvom øvelsen er god i momentet, virker den bedst, når man har
                øvet sig i det på forhånd. Det, at du får erfaring med at
                fokusere dine sanser, kan over tid gøre det til en naturlig del
                af din værktøjskasse.
            </LabelBody>
            <Tip className="my-30">
                Øvelsen er særligt god at lave udenfor. At få forbundet kroppen
                med naturen er en god måde at komme ud af hovedet på.
            </Tip>
            <Spacer />
            <SecondaryButton onClick={onContinue}>
                Afslut øvelsen
            </SecondaryButton>
        </>
    );
}
